import { Component } from '@theme/component';

/**
 * Announcement bar close button.
 *
 * Wraps the announcement bar and lets a visitor dismiss it for the current page
 * view only. The choice is not persisted, so the bar comes back on the next
 * refresh or navigation.
 *
 * @extends {Component}
 */
export class AnnouncementBarClose extends Component {
  /**
   * Dismiss the announcement bar.
   */
  dismiss = () => {
    this.hidden = true;
    // Let the header group recalculate its height now the bar is gone.
    window.dispatchEvent(new Event('resize'));
  };
}

if (!customElements.get('announcement-bar-close')) {
  customElements.define('announcement-bar-close', AnnouncementBarClose);
}
